import { API_ENDPOINTS, apiRequest, HttpMethods } from "@alba-cars/common-modules";

import { DealDriveEstimateRequest, DealDriveEstimateResponse } from "@/lib/types";
import { tryCatch } from "@/utils/error-handling";

export const getBankValuationDealDriveEstimate = async (input: DealDriveEstimateRequest) => {
  const response = await tryCatch(makeRequest(input));

  return response;
};

const makeRequest = async (input: DealDriveEstimateRequest) => {
  const endpoint = API_ENDPOINTS.bankValuationRequest.estimate;

  const response = await apiRequest<DealDriveEstimateResponse>(endpoint, {
    method: HttpMethods.POST,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(input),
  });

  return response;
};
